// extracted by mini-css-extract-plugin
module.exports = {"getintouch":"styles_getintouch__ZCILc","rotate":"styles_rotate__8mjHv","rotate-reverse":"styles_rotate-reverse__2P94D"};